export enum SourcingProjectRequestItemField {
  POSITION = 'position',
  SOURCING_PROJECT_LOT_ID = 'sourcingProjectLotId',
  SUPPLIERS = 'suppliers',
  STATUS = 'status',
  LOT_ITEM_ID = 'lotItemId',
  SOURCING_PROJECT_ID = 'sourcingProjectId',
  ROUND_NUMBER = 'roundNumber',
  QUANTITY = 'quantity',
  PRICE_PER_UNIT = 'pricePerUnit',
  CURRENCY = 'currency',
  LOT_ITEM_TITLE = 'lotItemTitle',
  LOT_ITEM_DESCRIPTION = 'lotItemDescription',
  LOT_TITLE = 'lotTitle',
  LATEST_ROUND_NUMBER = 'latestRoundNumber',
  LOT_ITEM_UNIT = 'lotItemUnit',
}

export interface SourcingProjectRequestItemData {
  latestRoundNumber: number;
  position: string;
  lotItemTitle?: string | null;
  lotItemDescription?: string | null;
  status?: string | null;
  lotItemId?: string | null;
  quantity: number;
  lotTitle?: string | null;
  pricePerUnit?: number | null;
  currency?: string | null;
  roundNumber: number;
  lotItemUnit?: string | null;
  sourcingProjectLotId: string;
  suppliers?: string | null;
  sourcingProjectId: string;
}
